var map = {
	"./dialog/account/template.vue": [
		"iU/I",
		35
	],
	"./dialog/freeze/template.vue": [
		"wFhY",
		34
	],
	"./dialog/toogle/template.vue": [
		"FItL",
		33
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "yV53";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/components lazy ^\.\/dialog.*\.vue$
// module id = yV53
// module chunks = 37